goog.provide("shadow.js.shim.module$$tiptap$extension_heading");
goog.provide("module$shadow_js_shim_module$$tiptap$extension_heading");
shadow.js.shim.module$$tiptap$extension_heading = shadow.js.nativeProvides["@tiptap/extension-heading"] = shadow$bridge("@tiptap/extension-heading");
module$shadow_js_shim_module$$tiptap$extension_heading.default = shadow.js.shim.module$$tiptap$extension_heading;
